module.exports = __webpack_public_path__ + "static/media/achievement-office-clown.85437233.svg";